import { render } from "./alwaysVisible.vue?vue&type=template&id=72d48e63&scoped=true"
import script from "./alwaysVisible.vue?vue&type=script&lang=js"
export * from "./alwaysVisible.vue?vue&type=script&lang=js"

import "./alwaysVisible.vue?vue&type=style&index=0&id=72d48e63&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d48e63"]])

export default __exports__